import Utilities from '@/Utility/Utilities';

export default class CustomBindingUtilities {

    public static registerDisposable(disposable, bindings, bindingContext): void {
        let lookup = [bindings()];

        let bc = bindingContext;
        do {
            lookup.push(bc);
            lookup.push(bc.$data);

            bc = bc.$parentContext;
        }
        while (bc != null);

        let uiElement = null;
        for (let i = 0; i < lookup.length; i++) {
            let scope = lookup[i];
            if (scope == null) continue;

            if (scope.uiElement != null && Utilities.isFunction(scope.uiElement.registerDisposable)) {
                uiElement = scope.uiElement;
                break;
            }
        }

        if (uiElement != null) {
            uiElement.registerDisposable(disposable)
        }
        else {
            console.log("Konnte zu folgendem Objekt kein verantwortliches Eltern-Element finden:");
            console.log(disposable);
        }
    }

}